import { jsxs as f, jsx as p } from "react/jsx-runtime";
import { forwardRef as c, useCallback as I } from "react";
import e from "./styles.module.less.js";
const N = c(
  (a, r) => {
    var d;
    const {
      checked: n = !1,
      value: o,
      name: t,
      label: u,
      disabled: s,
      onChange: l,
      className: m,
      error: $
    } = a, h = I(
      (i) => {
        s || l(i.target.checked ? i.target.value : "");
      },
      [s, l]
    );
    return /* @__PURE__ */ f(
      "label",
      {
        className: `${e.radioInputLabel} ${n ? e.checked : ""} ${m} ${$ ? e.error : ""}`,
        htmlFor: `${t}-${o}`,
        children: [
          /* @__PURE__ */ p(
            "input",
            {
              id: `${t}-${o}`,
              ref: r,
              ...a.props,
              className: `${e.radioInput} ${((d = a.props) == null ? void 0 : d.className) || ""}`,
              type: "radio",
              name: t,
              value: o,
              checked: n,
              onChange: h,
              disabled: s
            }
          ),
          u
        ]
      }
    );
  }
);
N.displayName = "RadioInput";
const b = c(
  ({ children: a }, r) => /* @__PURE__ */ p("div", { ref: r, className: e.radioInputGroup, children: a })
);
b.displayName = "RadioInputGroup";
export {
  N as RadioInput,
  b as RadioInputGroup
};
